import { SELECT_MATERIAL, SELECT_EXPRESSION, SELECT_WALL_PANEL_MATCH_WORKTOP, SELECT_SPLASHBACK } from 'domain/Options/constants';
import { selectWallPanelMaterialId, selectWallPanelExpressionId, findById, findChildById, getParameterId } from 'domain/Options/reducers/plan';
import { SELECTION_TYPE_DEFAULT } from 'domain/Options/selectionTypes';
import * as parameters from '../planParameters';

function wallPanelReducer(state, action) {
  if (!state.getIn(['plan', 'wallPanelMatchWorktop'])) {
    return state;
  }

  let stateToUse = state;

  switch (action.type) {
    case SELECT_SPLASHBACK: {
      const materialId = getParameterId(stateToUse, parameters.material);
      const exprId = getParameterId(stateToUse, parameters.expression);
      const canMatch = findById(stateToUse, 'wallPanels', materialId) && findChildById(stateToUse, parameters.wallPanelMaterial, 'expressions', exprId);

      if (!canMatch) {
        return state.setIn(['plan', 'wallPanelMatchWorktop'], false);
      } else {
        return state;
      }
    }


    case SELECT_WALL_PANEL_MATCH_WORKTOP:
      // fall through

    case SELECT_MATERIAL: {
      const materialId = getParameterId(stateToUse, parameters.material);
      const exists = findById(stateToUse, 'wallPanels', materialId);
      if (exists) {
        stateToUse = selectWallPanelMaterialId(stateToUse, materialId, SELECTION_TYPE_DEFAULT, true);
      }
    }
    // fall through

    case SELECT_EXPRESSION: {
      const exprId = getParameterId(stateToUse, parameters.expression);
      const exists = findChildById(stateToUse, parameters.wallPanelMaterial, 'expressions', exprId);
      if (exists) {
        stateToUse = selectWallPanelExpressionId(stateToUse, exprId, SELECTION_TYPE_DEFAULT, true);
      }
    }
      break;

    default:
      break;
  }

  return stateToUse;
}

export default wallPanelReducer;
